import { V3Record } from 'data/helpers/V3Record.js'

export const Goal = V3Record('goal', {
  clubId: null,
  name: null,
  description: null,
  goalType: null,
  goalParams: null,
  icon: null,
  cover: null,
  startsOn: null,
  endsOn: null,
  visibility: null,
  rules: null,
  participantsCount: null,
  clubName: null,
  isChallenge: null,
  privacyCode: null,
  createdAt: null,
  updatedAt: null
}, {
  writeable: [
    'name',
    'description',
    'goalType',
    'icon',
    'cover',
    'startsOn',
    'endsOn',
    'visibility',
    'goalParams'
  ],
  fileAttrs: ['icon', 'cover']
})
